export default function RefusalCardIcon({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_3105_120565)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6 0C2.68628 0 0 2.68628 0 6C0 9.31372 2.68628 12 6 12C9.31372 12 12 9.31372 12 6C12 2.68628 9.31372 0 6 0ZM8.86364 5.59091H3.13636V6.40909H8.86364V5.59091Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_3105_120565'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
